//libs
import { styled } from '@nykaa/ui-components';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';

//global components
import TextField from '@nykaa/ui-components/TextField';

export const Button = styled.button<{ disabled: boolean }>`
  ${({ theme }) => theme.typography.type121}
  ${({ disabled, theme }) =>
    disabled
      ? `color: ${theme.colors.textDisabled};
      cursor: not-allowed;`
      : `color: ${theme.colors.textPrimary};
      cursor: pointer;
  `}
  
  width: 100%;
  background: ${({ theme }) => theme.colors.surface};
  padding: ${({ theme }) => theme.spacing.spacing40} ${({ theme }) => theme.spacing.spacing240};
  border-radius: ${({ theme }) => theme.borders.buttonBorderRadius};
  border: ${({ theme }) => `1px solid ${theme.colors.textOutline}`};
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Error = styled.p`
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.negativePrimary};
  height: ${({ theme }) => theme.spacing.spacing100};
  margin-top: ${({ theme }) => theme.spacing.spacing20};
`;

export const Title = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.spacing60};
  ${({ theme }) => theme.typography.type120};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.bodySmall};
  margin-bottom: ${({ theme }) => theme.spacing.spacing40};
  text-align: left;
`;

export const InputElement = styled(TextField)`
  width: 100%;
  border: none;
  height: ${({ theme }) => theme.spacing.spacing200};
  outline: none;
  border-radius: ${({ theme }) => theme.spacing.spacing10};
  outline: 0;
  background: ${({ theme }) => theme.colors.surface50};
  span {
    height: 2px;
  }
  input {
    height: 35px;
    background: transparent;
  }
  div {
    height: 100%;
    background: transparent;
  }
  min-width: auto;
`;

export const SlideContainer = styled.div`
  display: flex;
  position: relative;
  height: 16px;
`;

export const Range = styled.input<{ isPriority: boolean }>`
  position: absolute;
  top: -4px;
  height: 5px;
  width: 100%;
  background: none;
  -webkit-appearance: none;
  z-index: ${({ isPriority }) => (isPriority === true ? '1' : '0')};

  &::-webkit-slider-thumb {
    height: 15px;
    width: 15px;
    border: ${({ theme }) => theme.borders.radiusNone};
    background: ${({ theme }) => theme.colors.surface};
    border: 1.5px solid ${({ theme }) => theme.colors.secondary};
    border-radius: ${({ theme }) => theme.borders.radiusFull};
    pointer-events: auto;
    -webkit-appearance: none;
    background-color: ${({ theme, isPriority }) =>
    isPriority ? theme.colors.secondary : theme.colors.surface};
  }
  &::-moz-range-thumb {
    height: 15px;
    width: 15px;
    border: none;
    border: ${({ theme }) => theme.borders.radiusNone};
    background: ${({ theme }) => theme.colors.surface};
    border: 1.5px solid ${({ theme }) => theme.colors.secondary};
    border-radius: ${({ theme }) => theme.borders.radiusFull};
    pointer-events: auto;
    -moz-appearance: none;
    box-shadow: ${({ theme }) => `0 0 6px ${hexToRgb(theme.colors.inverse, 0.05)}`};
    background-color: ${({ theme, isPriority }) =>
    isPriority ? theme.colors.secondary : theme.colors.surface};
  }
`;

export const TrackContainer = styled.div`
  height: 2px;
  border-radius: ${({ theme }) => theme.borders.radius10};
  background: ${({ theme }) => theme.colors.surface30};
  position: relative;
  width: 100%;
  top: -2px;
`;

export const SliderTrack = styled.div<{ left: number; right: number }>`
  height: 2px;
  left: ${({ left }) => left + '%'};
  right: ${({ right }) => right + '%'};
  position: absolute;
  border-radius: ${({ theme }) => theme.borders.radius20};
  background-color: ${({ theme }) => theme.colors.secondary};
`;

export const TextFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(50% - ${({ theme }) => theme.spacing.spacing20});
`;

export const Text = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const LabelsContainer = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};
  justify-content: space-between;
`;

export const PriceLabel = styled.div`
  position: relative;
  ${({ theme }) => theme.typography.type120};
  color: ${({ theme }) => theme.colors.primary};
`;
